import { render, staticRenderFns } from "./EstoqueFilialPorCurvasPQR.vue?vue&type=template&id=a263eba4&scoped=true"
import script from "./EstoqueFilialPorCurvasPQR.vue?vue&type=script&lang=js"
export * from "./EstoqueFilialPorCurvasPQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a263eba4",
  null
  
)

export default component.exports